import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import retailers from './site-operational-status/retailers';
import isEmpty from './site-operational-status/isSiteOperationalStatusEmpty';


const siteOperationalStatus = combineReducers({
  retailers,
  isEmpty,
  isLoading: loadingStatusAccordingToReducer('siteOperationalStatusLoadingStatus'),

});

export default siteOperationalStatus;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/site-operational-status.reducer.js